<template>
  <div class='header-container'>
    <div class='wrapper'>
      <img class='logo' src='../assets/logo.png' alt='logo' @click='redirect("/")'/>
      <ul style='display: flex'>
        <li
          v-for='(nav, index) in navs'
          :key='index'
          :class='{ "route-item-wrapper": Array.isArray(nav.path) }'
        >
          <template v-if='Array.isArray(nav.path)'>
            <div :class='"nav-content " + (isActive(nav.path, nav.isGroup) ? "active" : "")'>{{nav.name}}</div>
            <ul :class='{"route-dropdown" : true, "group": nav.isGroup}'>
              <template v-if='!nav.isGroup'>
                <li v-for="p in nav.path"
                  :key="p.path"
                  :class='isActive(p.path, false) ? "active" : ""'
                  @click='redirect(p.path)'>{{p.name}}</li>
              </template>
              <template v-else>
                <li v-for='(p, idx) in nav.path' :key='idx'>
                  <div>{{p.name}}</div>
                  <ul>
                    <li v-for='d in p.data' :key='d.path' :class='isActive(d.path, false) ? "active" : ""' @click='redirect(d.path)'>{{d.name}}</li>
                  </ul>
                </li>
              </template>
            </ul>
          </template>
          <div v-else :class='"nav-content " + (isActive(nav.path, false) ? "active" : "")' @click='handleNavClick(nav)'>{{nav.name}}</div>
        </li>
        <li class="login-register">
          <div @click='handleLoginOrRegister'>控制台登录/注册</div>
        </li>
        <li class="app-download">
          <div @click="downLoadApp">
            云会议下载
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { CONSOLE_SITE_URL, MEETING_DOWNLOAD_URL } from '../utils/constants';

const headerNav = [
  {
    name: '产品与服务',
    isGroup: true,
    path: [
      { 'name': 'PaaS产品', data: [
        { name: '实时语音', path: '/product/ssyy' },
        { name: '实时视频', path: '/product/sssp' },
        { name: '互动白板', path: '/product/hdbb' },
        { name: '互动直播', path: '/product/hdzb' },
        { name: '云端录制', path: '/product/ydlz' },
        { name: '即时通讯', path: '/product/jstx' },
      ]},
      { 'name': 'SaaS产品', data: [
        { name: '云会议', path: '/introduce_meeting' },
        { name: '企业大学堂', path: '/introduce_weclass' },
      ]},
    ]
  },
  { name: '解决方案', path: [
      { name: '在线教育解决方案', path: '/resolution/onlineEducation' },
      { name: '远程医疗解决方案', path: '/resolution/telemedicine' },
      { name: '娱乐社交解决方案', path: '/resolution/socialEntertainment' },
      { name: '医学会议解决方案', path: '/resolution/medicalTreatment' },
      { name: '电力行业解决方案', path: '/resolution/powerIndustry' },
      { name: '公检法解决方案', path: '/resolution/publicSecurityOrgans' },
    ]
  },
  { name: '客户案例', path: '/case'},
  { name: '开发者中心', path: '/development'},
  // { name: '产品价格', path: '/price'},
  { name: '新闻动态', path: '/news'},
  // { name: '关于我们', path: '/about'},
  // { name: '联系我们', path: '/contact'},
];
export default {
  name: 'Header',
  data() {
    return {
      navs: headerNav,
    }
  },
  watch: {
    $route(newValue, oldValue) {
      setTimeout(() => {
        this.$forceUpdate();
      })
    }
  },
  methods: {
    downLoadApp() {
      window.open(MEETING_DOWNLOAD_URL);
    },
    isActive(path, isGroup = false) {
      if (Array.isArray(path)) {
        if (isGroup) {
          let flag = false;
          for (let i = 0; i < path.length; i++) {
            const data = path[i].data;
            if (data.map(p => p.path).includes(this.getUrl())) {
              flag = true;
              break;
            }
          }
          return flag;
        }
        return path.map(p => p.path).includes(this.getUrl())
      }
      return path.includes('?') ? path === this.getUrl() : location.pathname.includes(path);
    },
    handleNavClick(nav) {
      nav.target==="open" ? window.open(nav.path) : this.redirect(nav.path)
    },
    handleLoginOrRegister() {
      window.open(CONSOLE_SITE_URL);
    },
    getUrl() {
      return `${location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname}${location.search}`
    }
  },
}
</script>

<style lang="less">
.header-container {
  z-index: 9999;
  position: sticky;
  top: 0;
  font-size: 15px;
  color: #999999;
  background: linear-gradient(134deg,#2544a1 3%, #152664 96%);
  height: 93px;
  line-height: 93px;
  transition: all 0.3s;
  display: flex;
  min-width: 1200px;
  justify-content: center;
  > div {
    width: 1149px;
    margin: 0 auto;
    height: 100%;
    display: flex;
  }
  .logo {
    height: 44px;
    margin-top: 24px;
    margin-right: 80px;
    cursor: pointer;
  }
  ul {
    flex: 1;
    >li {
      display: inline-block;
      position: relative;
      height: 100%;
      .nav-content{
        outline: none;
        cursor:pointer;
        color: #fff;
        padding: 0 24px;
        font-size: 16px;
        line-height: 93px;
        height: 100%;
        &.active, &:hover {
          color: #718EFF;
        }
      }
      &.route-item-wrapper:hover .route-dropdown {
        display: block;
        &.group {
          display: flex;
        }
      }
      &.app-download {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 16px;
          > div {
            cursor: pointer;
            width: 109px;
            height: 32px;
            line-height: 31px;
            opacity: 1;
            border: 1px solid #ffffff;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            letter-spacing: 1px;
            text-align: center;
          }
      }
      &.login-register {
        //flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        > div {
          width: 152px;
          height: 34px;
          line-height: 34px;
          background: linear-gradient(
              134deg
              , #78a4ff 9%, #425ce5 96%, #425ce5 96%);
          border-radius: 4px;
          text-align: center;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 1px;
          cursor: pointer;
        }
        margin-left: 24px;
      }
    }
  }
  .el-dropdown:focus {
    outline: none;
  }
}
.route-dropdown {
  display: none;
  border-radius: 10px;
  top: 72px;
  position: absolute;
  left: 0;
  background: #fff;
  padding: 10px 0;
  min-width: 200px;
  &:after {
    content: '';
    position: absolute;
    left: 50px;
    top: -6px;
    transform: translate(-50%, 0);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
  }
  li {
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    display: block !important;
    color: #666666;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    &.active, &:hover {
      color: #66b1ff;
    }
  }
  &.group {
    display: none;
    > li {
      cursor: auto;
      min-width: 135px;
      display: inline-block !important;
      padding: 0 20px 0 25px;
      > div {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #4a6cf1;
        padding-bottom: 4px;
        border-bottom: 1px solid #e5e5e5;
      }
      >ul {
        padding-top: 10px;
        li {
          padding: 0 0 0 10px;
          color: #666666;
          font-size: 15px;
          font-weight: 400;
          line-height: 32px;
          &.active, &:hover {
            color: #5B79F2;
          }
        }
      }
    }
  }
}
</style>
